export const COURSE_CATEGORIES = [
  { name: "business", label: "Business" },
  { name: "financeAndAccounting", label: "Finance And Accounting" },
  { name: "itAndSoftware", label: "IT & Software" },
  { name: "officeProductivity", label: "Office Productivity" },
  { name: "personalDevelopment", label: "Personal Development" },
  { name: "design", label: "Design" },
  { name: "marketing", label: "Marketing" },
  { name: "lifestyle", label: "Lifestyle" },
  { name: "photographyAndVideo", label: "Photography & Video" },
  { name: "healthAndFitness", label: "Health & Fitness" },
  { name: "music", label: "Music" },
  { name: "teachingAndAcademics", label: "Teaching & Academics" },
  { name: "art", label: "Art" },
  { name: "cooking", label: "Cooking" },
  { name: "digitalArt", label: "Digital Art" },
  { name: "videoGames", label: "Video Games" },
  { name: "languages", label: "Languages" },
  { name: "boardGames", label: "Board Games" },
  { name: "softwareDevelopment", label: "Software Development" },
  { name: "general", label: "General" },
  { name: "investing", label: "Investing" },
  { name: "iDontKnowYet", label: "I don't know yet" },
  { name: "notSure", label: "Not Sure" },
]